import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { initSentry } from "./config";
import "./index.css";
import "./i18n";
import App from "./App.jsx";
import ErrorFallback from "./components/ErrorFallback";

initSentry();

createRoot(document.getElementById("root")).render(
  <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
    <ErrorFallback error={error} resetError={resetError} />
  )}>
    <App />
  </Sentry.ErrorBoundary>
);
